export default __webpack_public_path__ + "../images/1.png";